import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stock-area-config',
  templateUrl: './stock-area-config.component.html',
  styleUrls: ['./stock-area-config.component.scss'],
  standalone: false
})
export class StockAreaConfigComponent implements OnInit {
  ngOnInit(): void {
    const body = document.getElementsByTagName('body')[0];
    body.className = '';
    body.classList.add('subpage');
  }
}
